<template>
  <div style="padding: 0 52px;">
    <div style="margin: 10px -52px; height: 1px; background-color: #fff;"></div>
    <div class="tabs">
      <div class="links">
        <a :class="activeTabIndex === 0 ? 'active' : ''" @click="tabClick(0)">Overview({{total1}})</a>
        <a :class="activeTabIndex === 1 ? 'active' : ''" @click="tabClick(1)">Rewards({{total2}})</a>
        <a :class="activeTabIndex === 2 ? 'active' : ''" @click="tabClick(2)">Pending Review({{total3}})</a>
        <a :class="activeTabIndex === 3 ? 'active' : ''" @click="tabClick(3)">Unapproved({{total4}})</a>
        <a @click="tabClick(4)">Sign Out</a>
      </div>
      <div class="balance" @click="() => $refs.withDraw.show = true">
        <img src="../assets/svg/Icon_Coin.svg" alt="">
        <span>{{totalToken}} WorldKey Token</span>
      </div>
    </div>
    <div class="card-container">
      <div v-for="card in dataList" :key="card.id" class="card" style="width: calc((100% - 290px) / 5);">
        <img :src="card.image_url">
        <p style="margin-top: 10px;">Upload Date: {{ formatDate(card.updated_at) }}</p>
        <div class="divider"></div>
        <button @click="viewDetail(card)" style="width: 100%">View Detail</button>
      </div>
    </div>
    <div class="pagination">
      <button @click="prevPage">&lt;</button>
      <button v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }" @click="goToPage(page)">
        {{ page }}
      </button>
      <button @click="nextPage">&gt;</button>
    </div>
    <div>
      <div class="maskPanel" v-if="modalShow"></div>
      <div class="modal card" v-if="modalShow">
        <GltfView ref="gltfView1" style="height: 318px"/>
        <div class="divider"></div>
        <button @click="modalShow = false" style="width: 200px; margin: 0;">Done</button>
      </div>
    </div>
    <WithDraw ref="withDraw" @submitSuccess="withdrawSubmit" :totalToken="totalToken" />
  </div>
</template>

<script>
import {getUserModel, getUserToken} from '../service/getData'
import Cookies from 'js-cookie'
import GltfView from '../components/GltfView.vue'
import WithDraw from '../components/WithDraw.vue'

export default {
  components: {
    GltfView,
    WithDraw
  },
  data () {
    return {
      activeTabIndex: 0,
      dataList: [],
      currentPage: 1,
      totalPages: 1,
      pageSize: 10,
      total1: 0,
      total2: 0,
      total3: 0,
      total4: 0,
      modalShow: false,
      totalToken: 0
    }
  },
  mounted () {
    this.getData(true)
    this.getData(false, 1)
    this.getData(false, 2)
    this.getData(false, 3)
    this.getTotalToken()
  },
  methods: {
    initData () {
      this.dataList = []
      this.totalPages = 1
    },
    async getTotalToken () {
      const address = Cookies.get('address')
      if (address) {
        const res = await getUserToken({address})
        this.totalToken = res.score || res.data.score || '0'
      }
    },
    async getData (setData, t) {
      if (setData) {
        this.initData()
      }
      const address = Cookies.get('address')
      if (address) {
        const obj = {address, pageIndex: (this.currentPage - 1) * this.pageSize, pageSize: this.pageSize}
        if ((t && t !== 0) || this.activeTabIndex !== 0) {
          const type = t || this.activeTabIndex
          if (type === 1) {
            obj.is_withdraw = 1
            obj.is_approved = 1
          } else if (type === 2) {
            obj.is_pending = 1
          } else if (type === 3) {
            obj.is_approved = 2
          }
        }
        const res = await getUserModel(obj)
        if (res.data) {
          this['total' + ((t || this.activeTabIndex || 0) + 1)] = res.total || 0
          if (setData) {
            this.dataList = res.data
            this.totalPages = Math.ceil(res.total / this.pageSize)
          }
        }
      }
    },
    tabClick (index) {
      if (index === 4) {
        Cookies.remove('address')
        this.$router.push('/')
      } else {
        this.activeTabIndex = index
        this.getData(true)
      }
    },
    viewDetail (data) {
      this.modalShow = true
      setTimeout(() => {
        this.$refs.gltfView1.createObjects(data.file_url)
      }, 0)
    },
    prevPage () {
      if (this.currentPage > 1) {
        this.currentPage--
        this.getData(true)
      }
    },
    nextPage () {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
        this.getData(true)
      }
    },
    goToPage (page) {
      this.currentPage = page
      this.getData(true)
    },
    formatDate (d) {
      const date = new Date(d)
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

      const day = date.getDate() // 获取日期
      const month = months[date.getMonth()] // 获取月份
      const year = date.getFullYear() // 获取年份

      return `${month} ${day}/${year}`
    },
    withdrawSubmit () {
      this.getTotalToken()
    }
  }
}
</script>

<style scoped>
body {
  margin: 0;
  font-family: Arial, sans-serif;
  background-color: #000;
  color: #fff;
}
.tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  margin-bottom: 20px;
}
.tabs .links {
  display: flex;
  gap: 80px;
}
.tabs .links a {
  cursor: pointer;
}
.tabs a {
  color: #ffffff;
  text-decoration: none;
  font-size: 16px;
  padding-bottom: 18px; /* Adds more spacing below the text */
}
.tabs a.active {
  color: #00ffff;
  border-bottom: 2px solid #00ffff;
}
.tabs .balance {
  display: flex;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
}
.tabs .balance img {
  height: 32px;
  margin-right: 5px;
}
.card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}
.card {
  background-color: #222;
  padding: 15px;
  border-radius: 10px;
  text-align: center;
  border: 1px solid #fff;
}
.card img {
  width: 100%;
  border-radius: 10px;
}
.divider {
  width: 100%;
  margin: 10px 0;
  height: 1px;
  background-color: #fff;
}
.card button {
  padding: 10px 0;
  background-color: #00ffff;
  color: #000;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  margin: 12px 0;
  font-weight: 800;
  font-size: 14px;
}
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 5px;
}
.pagination button {
  padding: 5px 10px;
  background-color: #222;
  color: #00ffff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.pagination button.active {
  background-color: #00ffff;
  color: #000;
}
.maskPanel {
  top:0;
  left:0;
  position:fixed;
  z-index:99;
  opacity: 0.7;
  background: var(--neutral-900, #101313);
  width:100%;
  height:100%;
}
.modal {
  //width: 150px;
  //height: 115px;
  position:fixed;
  z-index:100;
  background:#000;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  display: flex;
  width: 680px;
  //height:398px;
  //padding: 44px 0px;
  flex-direction: column;
  align-items: center;
  //border-radius: var(--Corner01, 10px);
  //gap: 20px;
  border-radius: 12px;
  border: 1px solid #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/MyData.vue